import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { findByUsuario } from "./api-aluno-responsavel";
import { changeARAluno } from "../Usuario/api-usuario";
import { setUsuario } from "../Usuario/actions/actions";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { success } from "../../util/ToastUtil";
import SettingsCard, { SelectableList } from "../Configuracao/SettingsCard";

export default function AlunoResponsavelAtivoTable() {
  const usuario = useSelector((state) => state.usuario);
  const [alunosResponsavel, setAlunosResponsavel] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const dispatch = useDispatch();
  const usuarioId = usuario?.id;

  useEffect(() => {
    if (!usuarioId) return;
    findByUsuario(usuarioId).then((data) => {
      if (!data) return;
      if (data.error) {
        errorMessage(data.message);
      } else if (Array.isArray(data)) {
        setAlunosResponsavel(data);
      }
    });
  }, [usuarioId]);

  const handleAtivar = (ar) => {
    setIsSaving(true);
    changeARAluno(ar.aluno)
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        dispatch(setUsuario(data));
        success("Aluno selecionado.");
      })
      .finally(() => setIsSaving(false));
  };

  if (alunosResponsavel.length === 0) return null;

  return (
    <SettingsCard
      title="Aluno Selecionado"
      description="Aluno cujas informações são exibidas no sistema."
      contentPadding={false}
    >
      <SelectableList
        items={alunosResponsavel}
        getKey={(ar) => ar.codigo}
        getLabel={(ar) => ar.aluno.nome}
        isSelected={(ar) => usuario.arAlunoSelecionado?.codigo === ar.aluno.codigo}
        onSelect={handleAtivar}
        disabled={isSaving}
      />
    </SettingsCard>
  );
}
